import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ScrollingBanner = () => {
  const text =
    "AI-Powered SEO Tool * WordPress SEO Automation * One-Click SEO Fixes * Higher Google Rankings * Real-Time SEO Insights * Organic Traffic Growth *";

  const items = text.split("*");

  return (
    <>
    <p className="sr-only">
Seo Up Rank is an advanced AI powered SEO automation platform that
provides website audits, keyword research, SEO analysis, and ranking
optimization tools. Visit the official platform at https://novarsis.ai/
to improve your website search engine rankings and organic traffic.
</p>
    <section
      aria-label="AI SEO automation features and website optimization benefits"
      className="relative overflow-hidden bg-gradient-to-r from-white via-[#F9FBFF] to-white py-4 sm:py-6 md:py-8"
    >
      {/* Hidden SEO text for crawlers */}
      <p className="sr-only">
        Seo Up Rank provides AI-powered SEO automation tools, WordPress SEO
        optimization, real-time SEO analytics, and one-click SEO fixes to help
        businesses achieve higher Google rankings and organic traffic growth.
      </p>

      {/* Animated Scrolling Banner */}
      <motion.div
        role="list"
        aria-live="off"
        className="
          whitespace-nowrap
          font-extrabold
          text-[#008300]
          tracking-[0.1em] sm:tracking-[0.12em] md:tracking-[0.15em]
          leading-tight
          text-[1.6rem]
          sm:text-[2.8rem]
          md:text-[4.2rem]
          lg:text-[5.5rem]
        "
        animate={{ x: ["0%", "-100%"] }}
        transition={{
          ease: "linear",
          duration: 28,
          repeat: Infinity,
        }}
      >
        {[...Array(2)].map((_, i) => (
          <span key={i} className="mx-4 sm:mx-6 md:mx-10">
            {items.map((part, idx) => (
              <React.Fragment key={idx}>
                {/* SEO Keyword Item */}
                <span role="listitem" className="inline-block">
                  {part.trim()}
                </span>

                {/* Decorative separator */}
                {idx < items.length - 1 && (
                  <motion.span
                    aria-hidden="true"
                    className="
                      inline-block
                      mx-4 sm:mx-6 md:mx-10
                      text-[#008300]/60
                      text-[2rem]
                      sm:text-[3rem]
                      md:text-[4.5rem]
                      lg:text-[6rem]
                      font-bold
                    "
                    whileHover={{
                      rotate: 360,
                      scale: 1.2,
                      transition: { duration: 0.6, ease: "easeInOut" },
                    }}
                  >
                    ✦
                  </motion.span>
                )}
              </React.Fragment>
            ))}
          </span>
        ))}
      </motion.div>

      {/* Internal SEO Link */}
      <div className="sr-only">
      <div className="text-center mt-4">
        <Link
          to="/pricing"
          aria-label="View Seo Up Rank pricing plans"
          className="text-[#008300] font-semibold hover:underline"
        >
          Explore Our SEO Pricing →
        </Link>
      </div></div>
    </section></>
  );
};

export default ScrollingBanner;